import {useAtom} from 'jotai';
import {useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {HamburgerMenuIconComponent} from '@/components/Icons';
import {Sidebar} from '@/components/Sidebar';
import {MenuButton} from '@/components/Sidebar/MenuButton';
import {useSession} from '@/hooks';
import {useGA4WithParams} from '@/hooks/tracking';
import {mapSideInfoAtom} from '@/map/atom';
import {MapSideMenuType} from '@/map/enums';
import {paths, SERVICE_GUIDE} from '@/router';
import {FlexFullGrow} from '@/styled-components';
import {IssueReportModal} from '../IssueReportModal';
import {ReactComponent as IconExplorer} from './assets/explorer-icon-menu.svg';
import {ReactComponent as GuideIcon} from './assets/guide-icon.svg';
import {ReactComponent as OpinionIcon} from './assets/opinion-icon.svg';
import {ReactComponent as IconStarred} from './assets/pinned-brand-icon-menu.svg';
import {DataSourceMenu} from './DataSourceMenu';
import {MapSidePanel} from './SidePanel';

const OPINION_FIELDS = [
  {
    type: 'addressOpinion',
    name: '주소',
    hint: `주소 제안 내용을 입력해주세요.
(예) 치킨이 기가막혀 역삼점의 올바른 위치는 경기도 수원시 장안구 하률로 198번길, 2층입니다.`,
  },
  {type: 'etcOpinion', name: '기타', hint: '기타 제안 내용을 입력해주세요.'},
];

export const MapSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [{menu}, setSideInfo] = useAtom(mapSideInfoAtom);
  const [openOpinionPopup, setOpenOpinion] = useState<boolean>(false);
  const {isOpenPreRegistrationUser} = useSession();

  const tracking = useGA4WithParams();

  const replaceMapRoot = () => {
    navigate(
      {pathname: paths.map_root, search: location.search},
      {replace: true}
    );
  };

  const onMoreButtonClick = () => {
    setSideInfo({
      menu: MapSideMenuType.more,
      open: true,
    });
    navigate({pathname: paths.map_root, search: location.search});
  };

  const toggleOpinionOpen = () => setOpenOpinion((prev) => !prev);

  return (
    <>
      <Sidebar>
        {isOpenPreRegistrationUser && (
          <MenuButton
            to={`${paths.map_root}/${MapSideMenuType.stores}`}
            name="매장찾기"
            icon={IconExplorer}
            onClick={() => tracking('search_store')}
          />
        )}
        <MenuButton
          to={`${paths.map_root}/${MapSideMenuType.starredBrands}`}
          name="관심브랜드"
          icon={IconStarred}
          onClick={() => tracking('favorite_brand')}
        />
        <FlexFullGrow />
        <a
          target="_blank"
          href={
            isOpenPreRegistrationUser
              ? 'https://myfranchise.notion.site/f0561eeffa554663803568f03ae6156e?pvs=4' // 매장찾기 포함 서비스 가이드
              : SERVICE_GUIDE // 일반 서비스 가이드
          }
          rel="noreferrer"
        >
          <MenuButton name="가이드" icon={GuideIcon} />
        </a>
        <DataSourceMenu />
        <MenuButton
          name="제안·신고"
          icon={OpinionIcon}
          onClick={toggleOpinionOpen}
        />
        <MenuButton
          name="메뉴"
          className={menu === MapSideMenuType.more ? 'active' : ''}
          icon={HamburgerMenuIconComponent}
          onClick={onMoreButtonClick}
        />
      </Sidebar>
      <MapSidePanel replaceMapRoot={replaceMapRoot} />
      {openOpinionPopup && (
        <IssueReportModal fields={OPINION_FIELDS} onClose={toggleOpinionOpen} />
      )}
    </>
  );
};
